import AiInfinityRulesTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    AiInfinityRulesTable
  },
  data () {
    return {
      rules: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('aiInfinityRules.index.title'));
    this.$setBreadcrumbs([
      { label: this.$t('aiInfinityRules.index.breadcrumbs'), route: {} }
    ])
  },
  methods: {
    loadRules(params = {}) {
      API.aiInfinityRules.index(params).then(({data, meta}) => {
        this.rules = data
        this.meta = meta
      }).catch(error => {
        console.error('Error cargando reglas de AI Infinity:', error);
      })
    }
  }
})